import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-cobalt/5 px-5 py-6 sm:py-8" data-id="element-173" data-mp="3fyhq1vsbkxc4">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-174" data-mp="2eshb609h71dz">
        <p className="text-[13px] font-medium text-ink sm:text-base" data-id="element-175" data-mp="29txotyqyznl3">
          <span className="text-cobalt" data-id="element-176" data-mp="29s34omnivzi2">Ressources très visuelles, entièrement en français</span> ·
          Prêtes à imprimer ou à projeter · Classées par notion et par usage
        </p>
      </div>
    </section>;
}